module.exports = __webpack_public_path__ + "static/media/icon_2_1.7c237ab8.svg";